import { gql } from '@grandvisionhq/graphql';

const GET_CART_DISCOUNTS_BY_PROMOTION_IDENTIFIER = gql`
  query GetCartDiscountsByPromotionIdentifier($promotionIdentifier: String!) {
    getCartDiscountsByPromotionIdentifier(promotionIdentifier: $promotionIdentifier) {
      amount
      minimumQuantity
      type
    }
  }
`;

export { GET_CART_DISCOUNTS_BY_PROMOTION_IDENTIFIER };
//# sourceMappingURL=get-cart-discounts-by-promotion-identifier.js.map
